import { render, staticRenderFns } from "./EventBase.vue?vue&type=template&id=147adc2c&scoped=true&"
import script from "./EventBase.vue?vue&type=script&lang=js&"
export * from "./EventBase.vue?vue&type=script&lang=js&"
import style0 from "./EventBase.vue?vue&type=style&index=0&id=147adc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147adc2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
